import _ from "lodash";

function fetchDefaultHeaders(headers = {}) {
    const defaultHeaders = {
        headers: {
            "Api-Key": process.env.REACT_APP_API_KEY
        }
    }

    return _.merge(defaultHeaders, headers);
}

const api = {
    collectionAvatar: () => {
        return fetch(process.env.REACT_APP_API_BASE_URL + '/nft/collection/' + process.env.REACT_APP_NFT_COLLECTION_AVATAR_ID, fetchDefaultHeaders())
            .then(res => res.json());
    },
    checkVial: (address) => {
        // Vial Collection ID to check vials!
        return fetch(process.env.REACT_APP_API_BASE_URL + '/nft/vial/' + address + "_" + process.env.REACT_APP_NFT_COLLECTION_VIAL_ID, fetchDefaultHeaders())
            .then(res => res.json());
    },
    migrate: (vial_id, data) => {
        // Vial Collection ID to migrate vials!
        return fetch(process.env.REACT_APP_API_BASE_URL + '/nft/migrate/' + vial_id + "_" + process.env.REACT_APP_NFT_COLLECTION_VIAL_ID, fetchDefaultHeaders())
            .then(res => res.json());
    }
}

export default api;
